import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";

import { LoadingButton } from "@mui/lab";
import React from "react";

interface IProps {
    title: string;
    open: boolean;
    contentText: React.ReactElement | string;
    cancelText?: string;
    confirmationText?: string;
    cancelColor?: "inherit" | "error" | "primary" | "secondary" | "success" | "info" | "warning";
    cancelVarient?: "text" | "outlined" | "contained";
    confirmationColor?: "inherit" | "error" | "primary" | "secondary" | "success" | "info" | "warning";
    confirmationVarient?: "text" | "outlined" | "contained";
    onCancel?: () => void;
    onConfirmation?: () => void;
    isPerformingAction?: boolean;
    buttonIcon: React.ReactElement;
}

const PortalConfirmationDialog = (props: IProps) => {
    const {
        title,
        open,
        contentText,
        cancelText,
        confirmationText,
        onCancel,
        onConfirmation,
        confirmationColor,
        confirmationVarient,
        cancelColor,
        cancelVarient,
        isPerformingAction,
        buttonIcon,
    } = props;
    return (
        <Dialog sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }} maxWidth="xs" open={open}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent dividers>{contentText}</DialogContent>
            <DialogActions>
                <Stack direction="row" spacing={2}>
                    <Button
                        variant={cancelVarient ?? "contained"}
                        color={cancelColor ?? "error"}
                        autoFocus
                        onClick={onCancel}
                    >
                        {cancelText}
                    </Button>
                    <LoadingButton
                        aria-label={confirmationText}
                        onClick={onConfirmation}
                        color={confirmationColor ?? "success"}
                        variant={confirmationVarient ?? "outlined"}
                        loading={isPerformingAction}
                        startIcon={buttonIcon}
                        loadingPosition="start"
                    >
                        {confirmationText}
                    </LoadingButton>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};

export default PortalConfirmationDialog;
